



























import { Component, Vue } from "vue-property-decorator";
import { deleteExtension } from "@/services/customExtensions/customExtensionService";

@Component
export default class CustomExtensionDeleteModal extends Vue {
    extensionToBeDeleted: string = "";
    extensionName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(authorizationId: string, name: string) {
        this.extensionToBeDeleted = authorizationId;
        this.extensionName = name;
        this.$bvModal.show("modal-deleteExtension");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteExtension");
        this.extensionName = "";
        this.extensionToBeDeleted = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteExtension(this.extensionToBeDeleted).then(() => {
            this.$emit("reload");
            this.extensionName = "";
            this.extensionToBeDeleted = "";
            this.$bvModal.hide("modal-deleteExtension");
        });
    }
}
